import api from "./axiosConfig";

export default function createModuleApi(modulePath, options = {}) {
  const { endpoints = {}, unwrap = (res) => res.data.data.users } = options;

  const base = modulePath.endsWith("/") ? modulePath.slice(0, -1) : modulePath;

  const ep = (key, fallback) =>
    endpoints[key] !== undefined ? endpoints[key] : fallback;
  return {
    fetchAll: async () => {
      const res = await api.get(`${base}${ep("list", "/list-users")}`, {
        data: {},
      });
      return unwrap(res);
    },
    create: async (data) => {
      const res = await api.post(
        `${base}${ep("create", "/create-user")}`,
        data,
      );
      return res.data;
    },
    update: async (id, data) => {
      const res = await api.put(
        `${base}${ep("update", `/update-user/${id}`)}`,
        data,
      );
      return res.data;
    },
    remove: async (id) => {
      const res = await api.delete(
        `${base}${ep("delete", `/delete-user/${id}`)}`,
        { data: {} },
      );
      return res.data;
    },
  };
}
